<script setup>
import { BAlert, BContainer, BLink } from 'bootstrap-vue-next';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import FooterNote from './common/components/FooterNote.vue';
import NavigationMenu from './common/components/NavigationMenu.vue';
import { DEFAULT_TITLE } from './common/Constants';
import { useVueData } from './common/useVueData';
import NotFoundPage from './pages/NotFoundPage.vue';

const footerNoteData = ref({ customText: null, learnMoreHref: null });
const notFound = ref(false);

const { flash, userId, isAdmin } = useVueData();

const FLASH_VARIANTS = { alert: 'danger', notice: 'success' };
const flashMessages = ref(
  Object.entries(flash || {})
    .filter(([, message]) => message)
    .map(([type, message]) => ({ type, message, variant: FLASH_VARIANTS[type] || 'info', show: true })),
);

const refreshFooterNote = (routeMeta) => {
  const { customText, learnMoreHref } = routeMeta.footerNote || { customText: null, learnMoreHref: null };
  footerNoteData.value = { customText, learnMoreHref };
};

const router = useRouter();
router.beforeEach((to) => {
  if (to.name == null) {
    notFound.value = true;
    document.title = `Page not found - ${DEFAULT_TITLE}`;

    return;
  }

  notFound.value = false;
  const loggedIn = userId != null;

  const { requireAdmin, requireLogin, title } = to.meta;

  if (!loggedIn && (requireAdmin || requireLogin)) {
    window.location.href = `/login?return=${encodeURIComponent(to.fullPath)}`;

    return false;
  } else if (requireAdmin && !isAdmin) {
    return '/';
  }

  document.title = title ? `${title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  refreshFooterNote(to.meta);
});
</script>

<template>
  <NavigationMenu />
  <BContainer class="pt-2">
    <BAlert
      v-for="flashMessage in flashMessages"
      :key="flashMessage.type"
      v-model="flashMessage.show"
      :variant="flashMessage.variant"
      dismissible
    >
      {{ flashMessage.message }}
    </BAlert>
    <NotFoundPage v-if="notFound" />
    <router-view v-else />
    <hr>
    <FooterNote
      :custom-text="footerNoteData.customText"
      :learn-more-href="footerNoteData.learnMoreHref"
    />
    <p>
      <a
        href="https://gitlab.com/gitlab-org/developer-relations/contributor-success/contributors-gitlab-com"
        target="_blank"
      >View source</a>
      ||
      <BLink
        :to="{ name: 'documentation', params: { page: 'user-guide' }, hash: '#get-help' }"
      >
        Get help
      </BLink>
      ||
      <!-- OneTrust Cookies Settings button start -->
      <a
        class="ot-sdk-show-settings"
        href="#"
      >
        Cookie settings
      </a>
      <!-- OneTrust Cookies Settings button end -->
    </p>
  </BContainer>
</template>
